module.exports = __webpack_public_path__ + "static/media/user.f2732091.svg";